import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Send, Clock, MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import Footer from './components/Footer';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      toast.error("Preencha todos os campos obrigatorios");
      return;
    }
    const mailtoLink = `mailto:suporteatlasia@hotmail.com?subject=${encodeURIComponent(formData.subject || 'Contato via Atlas.IA')}&body=${encodeURIComponent(`Nome: ${formData.name}\nEmail: ${formData.email}\n\n${formData.message}`)}`;
    window.open(mailtoLink, '_blank');
    toast.success("Redirecionando para seu email...");
  };

  return (
    <div className="app-container" data-theme="dark" style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <Link to="/">
          <Button variant="ghost" style={{ marginBottom: '1.5rem' }} data-testid="contact-back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao inicio
          </Button>
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
          <MessageCircle className="w-8 h-8" style={{ color: '#00ffff' }} />
          <h1 style={{ fontSize: '1.75rem', fontWeight: '700' }}>Contato</h1>
        </div>
        <p style={{ color: '#888', marginBottom: '2rem' }}>Entre em contato com a equipe Atlas.IA</p>

        {/* Contact Info */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem', marginBottom: '2rem' }}>
          <Card style={{ background: '#1a1a1a', border: '1px solid #333' }}>
            <CardContent style={{ padding: '1.25rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: '#00ffff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Mail className="w-5 h-5" style={{ color: '#000' }} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '0.75rem', marginBottom: '0.25rem' }}>Email</p>
                <a href="mailto:suporteatlasia@hotmail.com" style={{ color: '#00ffff', fontSize: '0.9rem', fontWeight: '600', textDecoration: 'none' }} data-testid="contact-email-link">
                  suporteatlasia@hotmail.com
                </a>
              </div>
            </CardContent>
          </Card>

          <Card style={{ background: '#1a1a1a', border: '1px solid #333' }}>
            <CardContent style={{ padding: '1.25rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{ width: '44px', height: '44px', borderRadius: '10px', background: '#8b5cf6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Clock className="w-5 h-5" style={{ color: '#fff' }} />
              </div>
              <div>
                <p style={{ color: '#888', fontSize: '0.75rem', marginBottom: '0.25rem' }}>Tempo de resposta</p>
                <p style={{ fontSize: '0.9rem', fontWeight: '600' }}>Ate 48 horas uteis</p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Contact Form */}
        <Card style={{ background: '#1a1a1a', border: '1px solid #333' }}>
          <CardHeader>
            <CardTitle style={{ fontSize: '1.1rem' }}>Envie sua mensagem</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                  <label style={{ color: '#888', fontSize: '0.8rem', display: 'block', marginBottom: '0.5rem' }}>Nome *</label>
                  <Input
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="Seu nome"
                    style={{ background: '#0f0f0f', border: '1px solid #333' }}
                    data-testid="contact-name-input"
                  />
                </div>
                <div>
                  <label style={{ color: '#888', fontSize: '0.8rem', display: 'block', marginBottom: '0.5rem' }}>Email *</label>
                  <Input
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder="seu@email.com"
                    style={{ background: '#0f0f0f', border: '1px solid #333' }}
                    data-testid="contact-email-input"
                  />
                </div>
              </div>

              <div>
                <label style={{ color: '#888', fontSize: '0.8rem', display: 'block', marginBottom: '0.5rem' }}>Assunto</label>
                <Input
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  placeholder="Sobre o que deseja falar?"
                  style={{ background: '#0f0f0f', border: '1px solid #333' }}
                  data-testid="contact-subject-input"
                />
              </div>

              <div>
                <label style={{ color: '#888', fontSize: '0.8rem', display: 'block', marginBottom: '0.5rem' }}>Mensagem *</label>
                <textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  placeholder="Descreva sua dúvida, sugestão ou problema..."
                  rows={5}
                  style={{
                    width: '100%',
                    background: '#0f0f0f',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    padding: '0.75rem',
                    color: '#fff',
                    fontSize: '0.9rem',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                  data-testid="contact-message-input"
                />
              </div>

              <Button
                type="submit"
                style={{ background: '#00ffff', color: '#000', fontWeight: '600', alignSelf: 'flex-start' }}
                data-testid="contact-submit-btn"
              >
                <Send className="w-4 h-4 mr-2" />
                Enviar Mensagem
              </Button>
            </form>
          </CardContent>
        </Card>

        {/* FAQ Quick Links */}
        <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#1a1a1a', border: '1px solid #333', borderRadius: '8px' }}>
          <h3 style={{ fontWeight: '600', marginBottom: '0.75rem' }}>Links úteis</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
            <Link to="/privacidade" style={{ color: '#00ffff', fontSize: '0.85rem', textDecoration: 'none' }}>Política de Privacidade</Link>
            <span style={{ color: '#333' }}>|</span>
            <Link to="/reembolso" style={{ color: '#00ffff', fontSize: '0.85rem', textDecoration: 'none' }}>Política de Reembolso</Link>
            <span style={{ color: '#333' }}>|</span>
            <Link to="/termos" style={{ color: '#00ffff', fontSize: '0.85rem', textDecoration: 'none' }}>Termos de Uso</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
